import {ActionTypes} from "../action-type"
export const setHeader = (status)=>{
    return {
        type: ActionTypes.HEADER_LENGTH,
        payload: status
    }
}